export default class CategoryController {
	constructor($root) {
		this.$root = $root;

		this.currentCategoryId = null;

		this.CHANGE_CATEGORY_EVENT = 'changeCategory';

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('Courses Category Controller: Root element is not defined.');
		}

		this.addEventListeners();
	}

	addEventListeners() {
		this.addChangeCategoryListener();
	}

	subscribe(name, callback) {
		if (!name || !callback) return;

		this.$root.addEventListener(name, callback);
	}

	dispatchEvent(name, payload = null) {
		if (!name) return;

		this.$root.dispatchEvent(new CustomEvent(name, {
			'detail': payload
		}));
	}

	addChangeCategoryListener() {
		this.$root.addEventListener('click', (e) => {
			const $target = e.target;

			if (!$target.dataset.category) return;

			this.$root.parentElement.classList.remove(`-${this.currentCategoryId}`);
			this.$root.parentElement.classList.add(`-${$target.dataset.category}`);
			this.dispatchEvent(this.CHANGE_CATEGORY_EVENT, $target.dataset.category);
		});

		this.subscribe(this.CHANGE_CATEGORY_EVENT, (e) => {
			this.setCategory(e.detail);
			this.setActiveCategoryControl();
		});
	}

	setActiveCategoryControl() {
		const $newActiveControl = this.$root.querySelector(`[data-category="${this.currentCategoryId}"]`);

		if (!$newActiveControl ||
			$newActiveControl.classList.contains('-active')) return;

		// Deactivate current active btn
		this.dropActiveCategoryControl();

		// Set new active btn
		$newActiveControl.classList.add('-active');
	}

	dropActiveCategoryControl() {
		const $activeControl = this.$root.querySelector('.cats-list_btn.-active');

		if (!$activeControl) return;

		$activeControl.classList.remove('-active');
	}

	setCategory(id) {
		this.currentCategoryId = id;
	}
}